












import { Component } from 'vue-property-decorator';
import { IBusinessType } from '@/models/business';
import BusinessService from '@/api/BusinessService';
import {
  getIsRewardActivated,
  isFeatureAllowsNotHaveReward
} from '@/utils/rewards';

import FilledButton from '../FilledButton/FilledButton.vue';
import { Group } from '@/router/group.model';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import RewardsModel from '@/componentsV2/templates/RewardsModel/RewardsModel.vue';

@Component({
  components: {
    FilledButton
  }
})
export default class BannerActivateRewards extends RewardsModel {
  service: BusinessService = new BusinessService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get allowRewardAccess() {
    return (
      this.business.type === IBusinessType.INSTORE &&
      this.$route &&
      this.$route.meta &&
      this.$route.meta.$group &&
      this.$route.meta.$group.id !== 'loyalty-program'
    );
  }

  get rewardsDeactivation() {
    if (this.allowRewardAccess) return false;
    return !getIsRewardActivated(this.currentGroup);
  }

  get currentGroup(): Group {
    return this.$route.meta.$group;
  }

  get rewardStatus() {
    return this.$store.getters['business/getRewardStatus'] || {};
  }

  get text() {
    if (isFeatureAllowsNotHaveReward())
      return 'Welcome Coins available through the Twism APP. Activate your Loyalty Rewards Program to make the campaign available to members through the widget as well.';

    if (this.currentGroup.id === 'loyalty-program')
      return '<span>Activate your Loyalty Rewards Program</span> to access details on this page.';

    return 'Activate your Loyalty Rewards Program to make the campaign available to members through the widget.';
  }

  onActivateRewards() {
    const { startBy } = this.$store.getters['startGuide/getPreferences'];
    const currentProvider = this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
    if (
      (this.business.type === IBusinessType.ONLINE ||
        (this.business.type === IBusinessType.BOTH &&
          this.currentGroup.id !== 'loyalty-program')) &&
      !currentProvider
    ) {
      this.openRewardsProgramModal({
        operationType: this.business.operationType
      });
    } else
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `toggleRewardsModal`,
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        }),
        {
          activeRewards: !getIsRewardActivated(),
          type:
            this.rewardStatus.operationType ||
            startBy ||
            this.business.operationType,
          origin: 'banner'
        }
      );
  }
}
